import SingleImageUploader from './SingleImageUploader.jsx';
import MultipleImageUploader from './MultipleImageUploader.jsx';

export {SingleImageUploader, MultipleImageUploader}



// WEBPACK FOOTER //
// ./components/uploader/index.js